import { Component, OnInit } from '@angular/core';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGrigPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import { GlobalApiService } from 'src/app/services/global-api.service';
import * as moment from 'moment';
import * as momentTime from 'moment-timezone';
import { ParentChildrenService } from 'src/app/services/parent-children.service';
import {
  BatchScheduleEvent,
  BatchScheduleEventsRes,
  childInfo,
  CLASS_CARD_TEXT,
  classCardColors,
} from 'src/app/constants/constants';

@Component({
  selector: 'app-classes-calendar',
  templateUrl: './classes-calendar.component.html',
  styleUrls: ['./classes-calendar.component.scss'],
})
export class ClassesCalendarComponent implements OnInit {
  timezones = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'Asia/Calcutta',
  ];
  calendarPlugins = [
    dayGridPlugin,
    timeGrigPlugin,
    interactionPlugin,
    bootstrap5Plugin,
  ];

  calendarOptions: CalendarOptions = {
    plugins: this.calendarPlugins,
    initialView: 'timeGridWeek',
    weekends: true,
    headerToolbar: {
      start: 'prev,next',
      center: 'title',
      end: 'timeGridDay,timeGridWeek,dayGridMonth',
    },
    buttonIcons: {
      prev: 'arrow-left',
      next: 'arrow-right',
    },
    themeSystem: 'bootstrap5',
    dayMaxEvents: 4,
    views: {
      timeGridWeek: {
        eventMaxStack: 2,
      },
      timeGridDay: {
        eventMaxStack: 2,
      },
    },
  };

  timezone: string = '';
  // selectedChild: childInfo = {
  //   zipcode: '',
  //   country: '',
  //   skype: '',
  //   haveAcademicCoaching: false,
  //   address: '',
  //   gender: 0,
  //   mobile: '',
  //   last_name: '',
  //   student_id: 0,
  //   first_name: '',
  //   haveTestPrep: false,
  //   email: '',
  // };
  selectedChild: number = 0;
  dataLoading: boolean = true;
  roleId: string | null = localStorage.getItem('roleId');

  events: EventInput[] = [];
  constructor(
    private globalApiService: GlobalApiService,
    private parentChildrenService: ParentChildrenService
  ) {}

  ngOnInit(): void {
    // this.getStudentClasses();
    if (localStorage.getItem('roleId') !== '4') {
      this.getStudentClasses();
    } else {
      this.parentChildrenService
        .getSelectedChildren()
        .subscribe((childIndex: string) => {
          this.selectedChild = parseInt(childIndex);
          this.getStudentClasses();
        });
    }
    var sone = momentTime.tz.guess();
    var timezone = momentTime.tz(sone).zoneAbbr();
    this.timezone = timezone;
    const date = momentTime.tz('8:00 PM', 'h:mm A', 'America/Chicago');
    console.log(date);
    var newD = date.clone().tz(sone);
    console.log(
      newD,
      newD.format('h:mm A'),
      newD.tz(),
      date.format('h:mm A'),
      date.tz()
    );
    const date1 = moment(date.format('YYYY-MM-DD'));
    const newD1 = moment(newD.format('YYYY-MM-DD'));
    console.log(date.diff(newD, 'day'), newD1.diff(date1, 'day'));
  }

  // getSelectedChildFromParentChildService() {
  //   this.selectedChild = this.parentChildrenService.getSelectedChild();
  // }

  getChildId() {
    const children = JSON.parse(localStorage['children']) || [];
    return children[this.selectedChild].student_id;
  }

  getStudentClasses() {
    this.dataLoading = true;
    let userId =
      localStorage['roleId'] === '4'
        ? this.getChildId()
        : localStorage['userId'];
    this.globalApiService.getStudentBatchScheduleEvents(userId).subscribe(
      (response: BatchScheduleEventsRes) => {
        this.dataLoading = false;
        // isDisabled === 1 is the "Active" checkbox on the batch schedule
        const enabledEvents = (response?.data || []).filter(
          (event: BatchScheduleEvent) => event.isDisabled === 1
        );

        let sone = momentTime.tz.guess();

        const constructedEvents: EventInput[] = enabledEvents.map(
          (event: BatchScheduleEvent) => {
            const course = [...new Set(event.courses || [])].join(', ');
            // Same colours as the admin calendar
            const colors = classCardColors(event.subject, event.hideDetails);
            const batchZone = this.timezones[event.timeZone - 1];
            const start = momentTime
              .tz(
                `${event.classDate} ${event.startTime}`,
                'MM-DD-YYYY h:mm A',
                batchZone
              )
              .tz(sone);
            const end = momentTime
              .tz(
                `${event.classDate} ${event.endTime}`,
                'MM-DD-YYYY h:mm A',
                batchZone
              )
              .tz(sone);
            // Classes that run past midnight end on the next day
            if (end.isSameOrBefore(start)) {
              end.add(1, 'day');
            }
            return {
              id: String(event.bseId),
              title: event.title || event.subject_display_name,
              start: start.toDate(),
              end: end.toDate(),
              // Timed events default to a dot in month view; the card styles need a filled block
              display: 'block',
              classNames: ['student-class-card'],
              backgroundColor: colors.tint,
              borderColor: colors.accent,
              textColor: CLASS_CARD_TEXT,
              extraParams: {
                ...event,
                course,
                startTime: start.format('h:mm A'),
                endTime: end.format('h:mm A'),
              },
            };
          }
        );
        this.events = constructedEvents;
      },
      (error: any) => {
        this.dataLoading = false;
      }
    );
  }

  eventResize(event: any, delta: any, revertFunc: any) {
    var endDate = event.end.format().toString();
    var startDate = event.start.format().toString();
  }
}
